import { Alignment } from "./Alignment"

export function getAlignmentContainerClassName(alignment: Alignment) {
  switch (alignment) {
    case Alignment.LEFT:
      return "d-flex justify-content-start"
    case Alignment.CENTER:
      return "d-flex justify-content-center"
    case Alignment.RIGHT:
      return "d-flex justify-content-end"
    case Alignment.BLOCK:
      return "d-flex justify-content-stretch"
    default:
      return ""
  }
}
